import { useMemo, useState } from "react";
import PropTypes from "prop-types";
import submit from "submit-form";
import Modal from "../../../../parts/modal-new";
import getAvatarUrl from "../../../../utils/get-avatar-url";
import SvgIcon from "../../../../parts/SvgIcon";

export const SummaryOrganizationBillingModalComponent = ({ locals }) => {
  const [sortConfig, setSortConfig] = useState({
    sortKey: "name",
    sortDirection: "ascending",
  });
  const { activeUser, organizationBilling } = locals;
  const { webAppTheme = "dark" } = activeUser;
  const { report: { reportByCoach = [], totalAmount = null } = {} } =
    organizationBilling ?? {};
  const { sortKey, sortDirection } = sortConfig;

  /**
   * Function to close the modal
   */
  const handleClose = () => {
    submit(`/actions/refresh/`, {
      method: "GET",
      body: { modal: "" },
    });
  };

  /**
   * Function to sort the content by name or amount
   * @param {*} e 
   * @param {*} orderBy 
   */
  const handleSort = (e, orderBy) => {
    e.preventDefault();
    setSortConfig({
      sortKey: orderBy,
      sortDirection:
        sortKey === orderBy && sortDirection === "ascending"
          ? "descending"
          : "ascending",
    });
  };

  /**
   * Handle the sorting
   */
  const sortedReportByCoach = useMemo(() => {
    return [...reportByCoach].sort((a, b) => {
      const aValue =
        sortKey === "amount" ? parseFloat(a.amountPerCoach) : a.coachName;
      const bValue =
        sortKey === "amount" ? parseFloat(b.amountPerCoach) : b.coachName;
      return (
        (aValue < bValue ? -1 : 1) * (sortDirection === "ascending" ? 1 : -1)
      );
    });
  }, [reportByCoach, sortKey, sortDirection]);

  return (
    <Modal className="summary-organization-billing" title={"Summary"}>
      <div className="body">
        <table role="report-table">
          <thead className="labels">
            <tr>
              <th className="name">
                <span>Coach</span>
                <SvgIcon
                  onClickFn={(e) => {
                    handleSort(e, "name");
                  }}
                  src={"/img/svg/up_down_arrows.svg"}
                />
              </th>
              <th className="email">Email</th>
              <th className="role">Role</th>
              <th className="amount">
                <span>Amount </span>
                <SvgIcon
                  onClickFn={(e) => {
                    handleSort(e, "amount");
                  }}
                  src={"/img/svg/up_down_arrows.svg"}
                />
              </th>
            </tr>
          </thead>
          <tbody>
            {sortedReportByCoach.map((item) => {
              const {
                coachEmail,
                coachAvatar,
                amountPerCoach,
                coachName,
                coachRole = "",
              } = item;
              const image = getAvatarUrl(
                { avatar: coachAvatar },
                null,
                webAppTheme,
                webAppTheme !== "dark" ? true : false
              );
              return (
                <tr className="report" key={coachEmail}>
                  <td className="name">
                    <img
                      src={image}
                      loading="lazy"
                      className="profile-picture w-8 h-8 rounded-full mr-2"
                    />
                    <span>{coachName}</span>
                  </td>
                  <td className="email">{coachEmail}</td>
                  <td className="role">{coachRole}</td>
                  <td className="amount">${amountPerCoach}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <div className="total">
          <div className="totalValue">
            <span>Total: </span>
            <span className="clipped font-semibold">{`$${totalAmount}`}</span>
          </div>
        </div>
        <div className="close-button">
          <button
            data-button-type="primary"
            onClick={(e) => {
              e.preventDefault();
              handleClose();
            }}
          >
            Done
          </button>
        </div>
      </div>
    </Modal>
  );
};

SummaryOrganizationBillingModalComponent.contextTypes = {
  locals: PropTypes.object,
};
